<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">Personal Information</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-3 mb-2">
                            <div class="col-12">
                                <div class="row g-3">
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">First name</label>
                                        <h6 class="mb-0">{{ user.first_name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Middle name</label>
                                        <h6 class="mb-0">{{ user.middle_name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Last name</label>
                                        <h6 class="mb-0">{{ user.last_name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Phone number</label>
                                        <h6 class="mb-0">{{ user.mobile }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">BVN</label>
                                        <h6 class="mb-0">{{ employee.bvn }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">NIN</label>
                                        <h6 class="mb-0">{{ employee.nin }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Gender</label>
                                        <h6 class="mb-0 text-capitalize">{{ user.gender }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Date of birth</label>
                                        <h6 class="mb-0">{{ $filters.date(user.date_of_birth) }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Marital status</label>
                                        <h6 class="mb-0 text-capitalize">{{ user.marital_status }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Nationality</label>
                                        <h6 v-if="employee.nationality" class="mb-0 text-capitalize">{{ employee.nationality.nationality }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Religion</label>
                                        <h6 class="mb-0 text-capitalize">{{ employee.religion }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Registered on</label>
                                        <h6 class="mb-0 text-capitalize">{{ $filters.date(employee.created_at, 1) }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-4 g-4">
                    <div class="col-lg-6">
                        <div class="card h-100 mb-0 shadow-sm">
                            <div class="card-header">
                                <h6 class="card-title mb-0">Residential Address</h6>
                            </div>
                            <div class="card-body">
                                <div v-if="employee.residential_address" class="row g-4">
                                    <div class="col-12">
                                        <label class="small text-muted">Street Address:</label>
                                        <h6 class="mb-0">{{ employee.residential_address.street_address }}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">State:</label>
                                        <h6 v-if="employee.residential_address.state" class="mb-0">{{
                                            employee.residential_address.state.name }}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Local Government:</label>
                                        <h6 v-if="employee.residential_address.lga" class="mb-0">
                                            {{ employee.residential_address.lga.name }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Nearest landmark:</label>
                                        <h6 class="mb-0">
                                            {{ $filters.textFromSlug(employee.residential_address.nearest_landmark) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Nature of accomodation:</label>
                                        <h6 class="mb-0">
                                            {{ employee.residential_address.nature_of_accomodation }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="card h-100 mb-0 shadow-sm">
                            <div class="card-header">
                                <h6 class="card-title mb-0">Origin Address</h6>
                            </div>
                            <div class="card-body">
                                <div v-if="employee.origin_address" class="row g-4">
                                    <div class="col-12">
                                        <label class="small text-muted">Street Address:</label>
                                        <h6 class="mb-0">{{ employee.origin_address.street_address }}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Local government:</label>
                                        <h6 v-if="employee.origin_address.lga" class="mb-0">{{ employee.origin_address.lga.name
                                            }}</h6>
                                        <h6 v-else class="mb-0">{{ employee.origin_address.city_name }}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">State:</label>
                                        <h6 v-if="employee.origin_address.state" class="mb-0">
                                            {{ employee.origin_address.state.name }}
                                        </h6>
                                        <h6 v-else class="mb-0">{{ employee.origin_address.state_name }}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Nearest landmark:</label>
                                        <h6 class="mb-0">
                                            {{ $filters.textFromSlug(employee.origin_address.nearest_landmark) }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.employee.user || this.fakeUserModel
        }
    }
}
</script>

<style></style>